import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import VueCookies from 'vue-cookies'
import 'vant/lib/index.css';
import { VueHammer } from 'vue2-hammer'
import '@toast-ui/calendar/dist/toastui-calendar.min.css';

import {
  Pagination,
  Loading,
  Tabbar,
  TabbarItem,
  Calendar,
  Cell,
  Tag,
  Form,
  CellGroup, Picker, Field, Popup, Empty, Icon, Row, Col, Divider, Button, Collapse, CollapseItem, Switch, Card, DatetimePicker
} from 'vant';
Vue.use(Element);

Vue.use(Form);
Vue.use(Tabbar);
Vue.use(Tag);
Vue.use(TabbarItem);
Vue.use(Calendar);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Picker);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Empty);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Divider);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Switch);
Vue.use(Button);
Vue.use(VueHammer);
Vue.use(Card);
Vue.use(VueCookies);
Vue.use(DatetimePicker);
Vue.use(Pagination);
Vue.use(Loading);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
